/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Material_Row_SuffixInputs */

const vi_material_row_suffix = /** @type {(inputs: Material_Row_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(vật tư)`)
};

/**

* @param {Material_Row_SuffixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const material_row_suffix = /** @type {((inputs?: Material_Row_SuffixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Material_Row_SuffixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_material_row_suffix(inputs)
});